import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {labels} from '../../../../../../../util/utils';
import Ellipses from '../../../../../EllipsesControl/EllipsesPresets';
import LoadingIndicator from '../../../../../LoadingIndicator/LoadingIndicator';
import GrayFade from '../../../../../GrayFade/GrayFade';
import MotifTextLink from '@ey/motif-react-wrapper/TextLink';

function ChildEntityListItem({className, id, selector, nameKey, showRemove = 'true', onRemove, fatherId, isModal}) {
	const element = useSelector((state) => selector(state, id));
	const [isHovering, setIsHovering] = useState(false);
	const [isDeleting, setIsDeleting] = useState(false);

	const onClickHandler = (e) => {
		e.stopPropagation();
		setIsDeleting(true);
		onRemove(fatherId, id, setIsDeleting);
	};

	return (
		<section
			onMouseEnter={() => {
				setIsHovering(true);
			}}
			onMouseLeave={() => {
				setIsHovering(false);
			}}
			className={`child-entity-list-item ${className}`}
		>
			{isModal && isDeleting ? (
				<LoadingIndicator indicatorType={'progress'} view={'inlineView'} show={isDeleting} label={labels.removing} />
			) : (
				<>
					<GrayFade isGrayFade={isDeleting} className="child-entity-list-item__name">
						<Ellipses.Single>{element[nameKey]}</Ellipses.Single>
					</GrayFade>
					{showRemove && isHovering && !isDeleting && (
						<div className="child-entity-list-item__remove-hyperlink">
							<MotifTextLink href="javascript:void(0)" onClick={onClickHandler}>
								{labels.remove}
							</MotifTextLink>
						</div>
					)}
				</>
			)}
		</section>
	);
}

ChildEntityListItem.propTypes = {
	className: PropTypes.string,
	selector: PropTypes.func.isRequired,
	nameKey: PropTypes.string.isRequired,
	showRemove: PropTypes.bool,
	onRemove: PropTypes.func,
	id: PropTypes.number.isRequired,
	fatherId: PropTypes.number.isRequired,
	isModal: PropTypes.bool
};

export default ChildEntityListItem;

export const ModalChildEntityListItem = styled(ChildEntityListItem)`
	margin: 0 var(--px-20);
	border-bottom: var(--px-1) solid var(--neutrals-200);
	padding: var(--px-7_5) 0;
	font-size: var(--px-14);
	&:hover {
		font-weight: 600;
	}

	.child-entity-list-item__name {
		display: inline-block;
		width: calc(100% - var(--px-60));
		padding-right: var(--px-10);
	}

	.child-entity-list-item__remove-hyperlink {
		display: inline-block;
		width: var(--px-60);
		color: var(--blue-600) !important;
		a {
			color: var(--blue-600) !important;
			&:hover {
				cursor: pointer;
			}
		}
	}
	.motif-progress-bar-wrapper-circle {
		height: var(--px-26) !important;
		width: var(--px-26) !important;
		margin: 0 auto;
	}
`;

export const CardViewChildEntityListItem = styled(ChildEntityListItem)`
	margin: var(--px-5) var(--px-5);
	padding: 0 var(--px-10);
	font-size: var(--px-14);
	&:hover {
		font-weight: 600;
	}

	.child-entity-list-item__name {
		display: inline-block;
		width: calc(100% - var(--px-60));
		padding-right: var(--px-10);
	}

	.child-entity-list-item__remove-hyperlink {
		display: inline-block;
		width: var(--px-60);
		color: var(--blue-600) !important;
		a {
			color: var(--blue-600) !important;
			&:hover {
				cursor: pointer;
			}
		}
	}
	}
`;

CardViewChildEntityListItem.displayName = 'CardViewChildEntityListItem';
